import {
  LayoutDashboard,
  LogOut,
  Shapes,
  User,
  Lightbulb,
  Briefcase,
  Home,
  Table as TableIcon,
  Wallet,
  Truck,
  Factory,
} from "lucide-react"
import type { LucideIcon } from "lucide-react"

export interface MenuItem {
  name: string
  /**
   * Componente do ícone da biblioteca `lucide-react`.
   * @example LayoutDashboard
   */
  icon: LucideIcon
  link: string
  /**
   * Array com os `user_roles` que podem ver este item.
   * Um array vazio `[]` significa que é visível para todos os usuários autenticados.
   */
  roles: number[]
  /** Se true, somente admin/master visualiza */
  adminOnly?: boolean
  active: boolean
  /**
   * Identificador para ações especiais que não são de navegação.
   */
  action?: "logout"
}

export const menuItems: MenuItem[] = [
  {
    name: "Dashboard",
    icon: LayoutDashboard,
    link: "/",
    roles: [], // Vazio significa que todos os usuários autenticados podem ver
    active: true,
  },
  {
    name: "Categorias",
    icon: Shapes, // Ícone para categorias
    link: "/categories",
    roles: [], // Visível para todos
    active: true,
  },
  {
    name: "Clientes",
    icon: User,
    link: "/clients",
    roles: [],
    active: true,
  },
  {
    name: "Designers",
    icon: Lightbulb,
    link: "/designers",
    roles: [],
    active: true,
  },
  {
    name: "Profissionais",
    icon: Briefcase,
    link: "/professionals",
    roles: [],
    active: true,
  },
  {
    name: "Projetos",
    icon: Home,
    link: "/projects",
    roles: [],
    active: true,
  },
  {
    name: "Tabelas",
    icon: TableIcon,
    link: "/tables",
    roles: [], // Visível para todos
    active: false,
  },
  {
    name: "Móveis",
    icon: TableIcon,
    link: "/furnitures",
    roles: [],
    active: true,
  },
  {
    name: "Orçamentos",
    icon: Wallet,
    link: "/budgets",
    roles: [],
    active: true,
  },
  {
    name: "Transportadoras",
    icon: Truck,
    link: "/carriers",
    roles: [],
    active: true,
  },
  {
    name: "Fábricas",
    icon: Factory,
    link: "/factories",
    roles: [],
    active: true,
  },
  {
    name: "Usuários",
    icon: User,
    link: "/users",
    roles: [],
    adminOnly: true,
    active: true,
  },
  {
    name: "Sair",
    icon: LogOut,
    link: "#", // Link placeholder, a ação será tratada pelo `action`
    roles: [],
    active: true,
    action: "logout",
  },
]